<form
	[formGroup]="uploadForm"
	(ngSubmit)="onSubmit()"
	class="flex flex-col h-full"
>
	<div class="flex flex-col gap-4 p-6 h-full overflow-y-auto pb-[77px]">
		<ui-section title="Upload Documents" type="sub-section">
			<atomic-dropzone
				section-content
				label="Upload Documents"
				[multiple]="true"
				(fileChanged)="onFileSelected($event)"
				class="[&>.dropzone]:!rounded-xl"
				[accept]="'.docx'"
			></atomic-dropzone>
		</ui-section>

		<ui-section
			[title]="'Selected files (' + uploadedFiles.length + ')'"
			type="sub-section"
		>
			<ng-container
				section-content
				*ngIf="uploadedFiles.length > 0; else noFiles"
			>
				<div class="space-y-4">
					<div
						*ngFor="let file of uploadedFiles; let i = index"
						class="p-4 rounded-xl border border-gray-200"
					>
						<div
							class="flex items-center justify-between cursor-pointer"
							(click)="toggleFileExpanded(i)"
						>
							<div class="text-gray-500 flex items-center gap-4">
								<p class="text-sm">{{ file.file.name }}</p>
							</div>
							<div class="flex items-center gap-2">
								<div
									class="flex gap-2 items-center justify-center rounded-md bg-gray-50 pl-3 pr-2 py-1.5"
								>
									<p class="p-sm">Add Details</p>
									<i-tabler
										name="chevron-up"
										[class.-rotate-180]="!file.expanded"
										class="w-4 h-4 duration-300"
									/>
								</div>
								<ui-button
									preset="DANGER"
									(click)="removeFile(i); $event.stopPropagation()"
									icon="minus"
									size="sm"
								/>
							</div>
						</div>

						<div
							class="grid grid-rows-[0fr] overflow-hidden transition-all duration-300"
							[class.grid-rows-[1fr]]="file.expanded"
						>
							<div class="min-h-0 space-y-2">
								<div class="flex-1 mt-4">
									<input
										type="text"
										[formControlName]="'displayName_' + i"
										class="w-full px-3 py-1.5 text-sm border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
										placeholder="Enter display name"
									/>
								</div>

								<textarea
									[formControlName]="'note_' + i"
									class="w-full px-3 py-1.5 text-sm border border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
									rows="2"
									placeholder="Add a note about this document..."
								></textarea>
							</div>
						</div>
					</div>
				</div>
			</ng-container>
			<ng-template #noFiles>
				<div
					class="text-center text-gray-500 border border-gray-200 rounded-xl px-4 py-5"
				>
					<p>No files selected</p>
				</div>
			</ng-template>
		</ui-section>

		<ui-section title="Notes" type="sub-section">
			<textarea
				section-content
				id="note"
				formControlName="note"
				class="w-full px-4 py-2 text-gray-700 bg-white border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 hover:border-gray-400 transition-colors duration-200"
				rows="4"
				placeholder="Add any additional notes or instructions about the requested documents..."
			></textarea>
		</ui-section>
	</div>

	<ui-content-footer
		[primaryAction]="primaryAction()"
		[secondaryAction]="secondaryAction()"
		[sticky]="true"
	></ui-content-footer>
</form>
